var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5a1 1 0 00-1 1v5H6a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V6a1 1 0 00-1-1z",
    fill: "#2C2D2E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDVDMTEuNDQ3NyA1IDExIDUuNDQ3NzIgMTEgNlYxMUg2QzUuNDQ3NzIgMTEgNSAxMS40NDc3IDUgMTJDNSAxMi41NTIzIDUuNDQ3NzIgMTMgNiAxM0gxMVYxOEMxMSAxOC41NTIzIDExLjQ0NzcgMTkgMTIgMTlDMTIuNTUyMyAxOSAxMyAxOC41NTIzIDEzIDE4VjEzSDE4QzE4LjU1MjMgMTMgMTkgMTIuNTUyMyAxOSAxMkMxOSAxMS40NDc3IDE4LjU1MjMgMTEgMTggMTFIMTNWNkMxMyA1LjQ0NzcyIDEyLjU1MjMgNSAxMiA1WiIgZmlsbD0iIzJDMkQyRSIvPgo8L3N2Zz4K";
export { SvgAddOutline24 as ReactComponent };